<script>
	export default {
		onLaunch: function() {
			console.log('App Launch')
		},
		onShow: function() {
			console.log('App Show')
		},
		onHide: function() {
			console.log('App Hide')
		}
	}
</script>

<style lang="scss">
	/*每个页面公共css */
	@import '@/uni_modules/uni-scss/index.scss';
</style>

<!-- ,
            "port" : 8080,
            "proxy" : {
                "/" : {
                    "target" : "https://dmtest.ahapp.net/preselect_interface"
                }
            } -->
